// CustomSelect.js
import React, { forwardRef } from 'react';

const SelectStatus = forwardRef(({ value, onChange, name, id, options, placeholder }, ref) => {
  return (
    <select
      id={id || name}
      name={name}
      value={value}
      onChange={onChange}
      ref={ref}
      className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring focus:ring-blue-600 shadow-lg"
    >
      {placeholder && <option value="">{placeholder}</option>}
      {options.map((option, index) => (
        <option key={index} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
});

export default SelectStatus;
